import { createContext } from 'react';

import { ContractedServices } from '@totem/types/contractedServices';

interface Context {
  loading: boolean;
  data: ContractedServices;
  doRefresh: () => void;
  organizationHasService: (service: string) => boolean;
  organizationHasApiSiteType: (apiSiteType: string) => boolean;
  buildingHasService: (buildingId: string, service: string) => boolean;
  buildingHasApiSiteType: (buildingId: string, apiSiteType: string) => boolean;
}

export default createContext<Context>({
  loading: false,
  data: null,
  doRefresh: () => {},
  organizationHasService: () => false,
  organizationHasApiSiteType: () => false,
  buildingHasService: () => false,
  buildingHasApiSiteType: () => false,
});
